import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '../../i18n';
export const PageSizeSelector = (props)=>{
    const { availableSizes, value, onChange } = props;
    const pageSizes = availableSizes.map((x)=>/*#__PURE__*/ _jsx("option", {
            value: x,
            children: x
        }, x));
    const { t } = useI18n();
    const itemsPerPageText = t('component.grid.pager.itemsPerPage');
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            itemsPerPageText,
            " ",
            /*#__PURE__*/ _jsx("select", {
                onChange: onChange,
                value: value,
                children: pageSizes
            })
        ]
    });
};
